import {NgModule} from '@angular/core';
import {Routes, RouterModule} from '@angular/router';

import {ChangePasswordComponent} from './pages/change-password.component';
import {LoginComponent} from './pages/login.component';
import {ResetPasswordComponent} from './pages/reset-password.component';
import {ManualComponent} from './pages/manual.component';
import {AuthGuard} from './services/auth.guard';
export const routes: Routes = [
    {
        path: '',
        redirectTo: 'login',
        pathMatch: 'full',
    },
    {
        path: 'login',
        component: LoginComponent,
        data: {
            title: 'ログイン'
        }
    },
    {
        path: 'change-password',
        component: ChangePasswordComponent,
        data: {
            title: 'パスワード'
        }
    },
    {
        path: 'reset-password',
        component: ResetPasswordComponent,
        data: {
            title: 'リセット'
        }
    },
    // マニュアル (src/assets/manuals/*.md)。同友用・提携先用はログイン画面から読めるよう公開、
    // 支部管理者用はログイン後
    {
        path: 'manual/member',
        component: ManualComponent,
        data: {title: '同友用マニュアル', file: 'member-manual.md', pub: true}
    },
    {
        path: 'manual/partner',
        component: ManualComponent,
        data: {title: '提携先用マニュアル', file: 'partner-manual.md', pub: true}
    },
    {
        path: 'manual/admin',
        component: ManualComponent,
        canActivate: [AuthGuard],
        data: {title: '支部管理者用マニュアル', file: 'admin-manual.md'}
    },
    {
        path: 'main',
        loadChildren: () => import('main/main.module').then(m => m.MainModule)
    },
    {
        path: 'legacy',
        loadChildren: () => import('legacy/legacy.module').then(m => m.LegacyModule)
    }
];

@NgModule({
    imports: [RouterModule.forRoot(routes)],
    exports: [RouterModule]
})
export class AppRoutingModule {
}
